<template>
  <div>
    <!-- Main navbar -->

    <div class="navbar navbar-expand-lg navbar-dark">
      <div class="navbar-brand">
        <a href="/" class="d-inline-block">
          <img src="@/assets/img/logo/logo_nps_portal.png" alt="" />
        </a>
      </div>
      <div class="d-flex flex-1 d-lg-none">
        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
          <i class="icon-paragraph-justify3"></i>
        </button>
      </div>

      <div class="d-flex flex-1 justify-content-end align-items-center">
        <ul class="navbar-nav flex-row">
          <li class="nav-item h-100">
            <a
              href="#"
              class="navbar-nav-link d-flex align-items-center h-100 py-1"
              aria-expanded="false"
            >
              <img
                :src="userPhoto"
                class="rounded-circle mr-xl-2"
                alt=""
                height="38"
              />
              <div class="d-flex flex-column mr-2">
                <div>{{ userName }}</div>
                <div class="text-muted">
                  <small>{{ unityName }}</small>
                </div>
              </div>
            </a>
          </li>
          <li class="nav-item">
            <a href="#" class="navbar-nav-link" @click="logout" title="Sair">
              <i class="icon-switch2"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import PATHS from '@/router/routesMap'

export default {
  name: 'Navbar',

  components: {},

  data() {
    return {
      showModalAccount: false,
    }
  },

  computed: {
    userName() {
      return this.$store.getters.user.name
    },
    unityName() {
      return this.$store.getters.user.unityName
    },
    userPhoto() {
      return this.$store.getters.user.photo
    },
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push(PATHS.BASE_URL)
      })
    },
  },
}
</script>
<style scoped>
.navbar-brand img {
  height: 18px;
}
</style>
